import { render, staticRenderFns } from "./NotificationCenterMainRow.vue?vue&type=template&id=2d7468bc&scoped=true&"
import script from "./NotificationCenterMainRow.vue?vue&type=script&lang=js&"
export * from "./NotificationCenterMainRow.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenterMainRow.vue?vue&type=style&index=0&id=2d7468bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7468bc",
  null
  
)

export default component.exports